// Utility functions for Notification components

export function formatDate(dateString: string) {
	const date = new Date(dateString);
	return date.toLocaleString(undefined, {
		year: "numeric",
		month: "short",
		day: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	});
}
